/**
 * This function links the background behavior of the header with the hamburguer menu
 */
const syncHamburguerState = () => {
    window.setInterval(() => {
        let hamburguerMenu = document.querySelector('.menu-drawer-container');
        let header = document.querySelector('sticky-header');

        //Check if the menu hamburguer is opened
        if (hamburguerMenu.classList.contains('menu-opening')) {
            header.classList.add('is-solid');
        } else {
            //Check if the user is scrolled y more than 10px
            if (window.scrollY < 10) {
                //remove the is-solid
                header.classList.remove('is-solid');
            }
        }
    }, 400);
};

const menuLinkFaker = () => {
    let productsLink = document.querySelector('.header__nav__item.Products');
    let productsLink2 = document.querySelector('.header__nav__item.모든제품');

    if (typeof productsLink !== 'undefined' && productsLink !== null) {
        productsLink.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.menu-drawer-icon').click();
        });
    }
    if (typeof productsLink2 !== 'undefined' && productsLink2 !== null) {
        productsLink2.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.menu-drawer-icon').click();
        });
    }
}

/**
 * This function will enable grou-accordions in the faqs page
 */
const buildUpFAQAccordions = () => {
    let faqPage = document.querySelector('.template.template--page.template--help');
    if (typeof faqPage !== 'undefined' && faqPage !== null) {
        //We're on the faq page, try to build the accordions
        let accordionsTitles = document.querySelectorAll('.section-accordions__title.h5');
        let accordionGroups = [];
        for (let i = 0; i < accordionsTitles.length; i++) {
            accordionGroups.push(accordionsTitles[i].parentNode);
        }

        //Apply styles and listeners for each group
        accordionGroups.forEach((group) => {
            //Add a floating chevron to the title
            let chevronDown = document.createElement('i');
            chevronDown.classList.add('fas', 'fa-chevron-down', 'section-accordions__title__chevron');
            group.querySelector('.section-accordions__title.h5').appendChild(chevronDown);
            //Also a hidden chevron up
            let chevronUp = document.createElement('i');
            chevronUp.classList.add('fas', 'fa-chevron-up', 'section-accordions__title__chevron');
            group.querySelector('.section-accordions__title.h5').appendChild(chevronUp);

            //first, hide the section-accordions__body child of the group
            group.querySelector('.section-accordions__body').style.display = 'none';
            //Hide the chevron up
            chevronUp.style.display = 'none';

            //Then add a click listener to the section-accordions__title h5
            group.querySelector('.section-accordions__title.h5').style.cursor = 'pointer';
            group.querySelector('.section-accordions__title.h5').addEventListener('click', (e) => {
                e.preventDefault();
                let groupBody = group.querySelector('.section-accordions__body');
                if (groupBody.style.display === 'none') {
                    groupBody.style.display = 'block';
                    chevronDown.style.display = 'none';
                    chevronUp.style.display = 'block';
                } else {
                    groupBody.style.display = 'none';
                    chevronDown.style.display = 'block';
                    chevronUp.style.display = 'none';
                }
            });
        });
    }
};


const getPredictiveResultsMainCollection = async () => {
    window.setInterval(() => {
        //Look for the anchor item
        let containers = document.querySelectorAll('.search-predictive-main-collection');
        containers.forEach((container) => {
            if(container.innerHTML.toString().length < 2) {
                //Get all the product collections
                let productId = container.getAttribute('data-product-id');
                fetch(`https://kave-home-korea.myshopify.com/api/2024-04/graphql.json`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': '6ffe2dd4025f3a99d63d430a3e422503',
                    },
                    body: JSON.stringify({
                        query: `query {
                            product(id: "gid://shopify/Product/${productId}") {
                              title
                              collections(first: 99) {
                                edges {
                                    node {
                                        title
                                        handle
                                        metafields: metafield(namespace: "custom", key: "is_main_collection") {
                                            value
                                            type
                                        }
                                    }
                                }
                              }
                            }
                        }`,
                        variables: {
                            id: 'gid://shopify/Product/' + productId
                        }
                    })
                })
                    .then(response => response.json())
                    .then(response => {
                        response.data.product.collections.edges.forEach(collection => {
                            if (collection.node.metafields != null) {
                                if (collection.node.metafields.value == 'true') {
                                    container.innerHTML = `<a href="/collections/${collection.node.handle}" class="custom-main-collection">${collection.node.title}</a>`;
                                }
                            }
                        });
                    });
            }
        });
    }, 1000);
};

const getPredictiveResultsTags = async () => {
    window.setInterval(() => {
        //Look for the anchor item
        let containers = document.querySelectorAll('.search-predictive-tags');
        containers.forEach((container) => {
            if(container.innerHTML.toString().length < 2) {
                //Get all the product collections
                let productId = container.getAttribute('data-product-id');
                fetch(`https://kave-home-korea.myshopify.com/api/2024-04/graphql.json`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': '6ffe2dd4025f3a99d63d430a3e422503',
                    },
                    body: JSON.stringify({
                        query: `query {
                            product(id: "gid://shopify/Product/${productId}") {
                              title
                                metafields: metafield(namespace: "custom", key: "etiquetas") {
                                  value
                                  type
                                }
                            }
                        }`,
                        variables: {
                            id: 'gid://shopify/Product/' + productId
                        }
                    })
                })
                    .then(response => response.json())
                    .then(response => {
                        if(response.data.product.metafields != null) {
                            let tags = response.data.product.metafields.value.toString().split(',');
                            tags.forEach(tag => {
                                container.innerHTML += `<label class="custom-tag tag-style__${tag.toString().toLowerCase().replace(' ', '-')}">${tag}</label>`;
                            });
                        }
                    });
            }
        });
    }, 1000);
};

window.setTimeout(() => {
    syncHamburguerState();
    menuLinkFaker();
    buildUpFAQAccordions();
    getPredictiveResultsMainCollection();
    getPredictiveResultsTags();
}, 1500);